import React from 'react';

export default function LegalFooter() {
    return (
        <footer className="legal-footer" role="contentinfo">
            © 2026 TEMTEC Limited. All rights reserved. Licensed for use under a paid commercial license agreement.
        </footer>
    );
}
